// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SecondaryCipNumberImporterHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import ResultDTO from '../models/ResultDTO';

interface Request {
    academicYearId: number;
    file: any | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            academicYearId: 0,
            file: null,
        },
        initValues);
    },
    academicYearId: 'academicYearId',
    file: 'file',
}

interface Result extends ResultDTO {
    file: any | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            file: null,
        },
        initValues);
    },
    file: 'file',
}

export { Request, Result };